import ApiClient, { ActionLogParams } from '../ApiClient'
import { AnalysisLogAction } from '../constants'

export type GenerateActionLog = (params: ActionLogParams) => void

export default function useTracking({ api }: { api: ApiClient | null }) {
  function generateActionLog(action: AnalysisLogAction) {
    return (params?: ActionLogParams) => {
      if (api && typeof api.logAnalysisAction === 'function') {
        api.logAnalysisAction(action, params)
      }
    }
  }
  return {
    logClickedBuyOnAmazon: generateActionLog(AnalysisLogAction.clickedBuyOnAmazon),
    logClickedBuyOnRakuten: generateActionLog(AnalysisLogAction.clickedBuyOnRakuten),
    logClickedPurchaseStepsButtonAmazon: generateActionLog(
      AnalysisLogAction.clickedPurchaseStepsButtonAmazon,
    ),
    logClickedPurchaseStepsButtonRakuten: generateActionLog(
      AnalysisLogAction.clickedPurchaseStepsButtonRakuten,
    ),
    logClickedLearnMoreAboutPremium: generateActionLog(
      AnalysisLogAction.clickedLearnMoreAboutPremium,
    ),
    logClickedBuyOnAmazonPostPurchaseModal: generateActionLog(
      AnalysisLogAction.clickedBuyOnAmazonPostPurchaseModal,
    ),
    logClickedBuyOnRakutenPostPurchaseModal: generateActionLog(
      AnalysisLogAction.clickedBuyOnRakutenPostPurchaseModal,
    ),
    logClickedPurchaseStepsButtonAmazonPostPurchaseModal: generateActionLog(
      AnalysisLogAction.clickedPurchaseStepsButtonAmazonPostPurchaseModal,
    ),
    logClickedPurchaseStepsButtonRakutenPostPurchaseModal: generateActionLog(
      AnalysisLogAction.clickedPurchaseStepsButtonRakutenPostPurchaseModal,
    ),
    logClickedLearnMoreAboutPremiumPostPurchaseModal: generateActionLog(
      AnalysisLogAction.clickedLearnMoreAboutPremiumPostPurchaseModal,
    ),
  }
}
